import { HomeContainer } from '@modules/home/containers/home_container';
import { Home } from '@modules/home/views/home_view';
import { createWebNavigateHandler } from '@/src/lib/navigation/createWebAppHandlers';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

export function HomeScreen() {
  const navigate = useNavigate();
  const onNavigate = useMemo(() => createWebNavigateHandler(navigate), [navigate]);

  return <HomeContainer View={Home} onNavigate={onNavigate} />;
}
